import { create } from 'zustand';
import type { User } from '../services/userService';

type AuthState = {
    user: User | null;
    initialized: boolean;

    setUser: (user: User) => void;
    clearUser: () => void;
    setInitialized: (value: boolean) => void;
};

export const useAuthStore = create<AuthState>((set) => ({
    user: null,
    initialized: false,

    setUser: (user) =>
        set({
            user,
        }),

    clearUser: () =>
        set({
            user: null,
        }),

    setInitialized: (value) =>
        set({
            initialized: value,
        }),
    resetUser: () =>
        set({
            user: null,
            initialized: false,
        }),
}));
